<template>
    <div
            class="chat-message"
            :class="{
                'chat-message_my': myTypes.indexOf(model.owner) > -1
            }"
    >
        <div
                v-if="model.handler === 'reminder_task'"
                class="chat-message__item"
        >
            <div>{{ $t('msg.reminderAt') }} {{ model.msg_aux.time }}</div>
            <div>
                {{ $t('msg.project') }}:
                <router-link :to="{name: 'tasks', params: {id: model.msg_aux.project_id}}">{{ model.msg_aux.project_name }}</router-link>
            </div>
            <div>
                {{ $t('msg.task') }}:
                <router-link :to="{name: 'tasks', params: {id: model.msg_aux.project_id}, query: {task_id: model.msg_aux.task_id}}">{{ model.msg_aux.task_name }}</router-link>
            </div>
        </div>
        <div
                v-else
                class="chat-message__item"
        >
          {{ model.msg }}
          <div class="chat-message__time">{{ dateString(model.created_at) }} {{ model.created_at | dateMin }}</div>
        </div>
    </div>
</template>

<script>
    export default {
        props: {
            model: {type: Object, default: () => {
                    return {
                        id: null,
                        user_id: null,
                        curator_id: null,
                        handler: null,
                        msg: null,
                        msg_aux: null,
                        owner: null,
                        is_read: null,
                        is_delete: null,
                        created_at: null,
                        updated_at: null,
                        read_at: null,
                        deleted_at: null
                    }
                }},
            myTypes: {type: Array, default: () => []}
        }
    }
</script>

<style lang="scss">
    @import 'src/assets/scss/vars';

    .chat-message {
        display: flex;

        &.chat-message_my {
            justify-content: flex-end;

            .chat-message__item {
                background-color: $colorSecondary;
            }
        }
        .chat-message__item {
            max-width: 80%;
            background-color: #eaeaea;
            padding: 3px 6px;
            border-radius: 5px;
            word-wrap: break-word;
            font-size: 12px;
        }
      .chat-message__time {
        font-size: 9px;
        color: #626262;
        margin-top: 2px;
      }
    }
</style>